import { makeAutoObservable } from 'mobx'

class User {
  isRegistered = false

  maxData: any = {}

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  initMax() {
    const initData = window.WebApp.initDataManager.rawInitData
    this.maxData = initData
  }

  checkUserRegister() {
    // const base64String = btoa(this.maxData)
    // const jsonData = JSON.stringify({
    //   data: base64String,
    // })

    // @TODO - тут проверка на регистрацию
    const response = { status: true, data: { result: true } }

    if (response.status) {
      this.isRegistered = response.data.result
    }
  }
}

export const userStore = new User()
